'use client';

import { useTranslations } from 'next-intl';

import { ButtonLink } from '@commons/components/Button';
import PageBuilder from '@commons/pagebuilder';
import type { WebinarNodeProps } from '@commons/pagebuilder/nodes/Webinar';
import GatedInsightDrawer from '@commons/pagebuilder/webforms/GatedInsightDrawer';
import type { DrupalBlock, DrupalLink } from '@commons/types/drupal';

/**
 * InsightWebinarWatchButton field block.
 *
 * Renders the gated webinar drawer CTA from a webinar URL field.
 */

const InsightWebinarWatchButton = ({ content }: DrupalBlock<DrupalLink>) => {
  const t = useTranslations('forms.gatedInsight');
  const page = PageBuilder.getPage<WebinarNodeProps>();

  const link = content || page?.link;
  if (!link?.url) return null;

  const label = page?.ctaLabel || t('watchNow');

  if (!page?.isGated) {
    return (
      <ButtonLink variant="primary" href={link.url} target="_blank" rel="noopener noreferrer">
        {label}
      </ButtonLink>
    );
  }

  return (
    <GatedInsightDrawer
      url={link.url}
      syncFormQueryParam
      resourceLabel={label}
      submitLabel={label}
      triggerProps={{ label, variant: 'primary' }}
    />
  );
};

export default InsightWebinarWatchButton;
